import React, { useRef } from "react";
import PortalModal from "../../Portals";
import {
  ButtonConfirm,
  CloseModal,
  ContentAlertText,
  ContentModal,
  ContentSelect,
  ModalTitle,
  SelectStyles,
  TextModal,
  TitleAlert,
} from "./ModalConfirmCaseUpdated.styled";
import Select from "react-select";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import { Form } from "react-bootstrap";

const ModalConfirmCaseUpdated = ({
  modalTitle,
  modalAlertTitle,
  open,
  setOpen,
  fn,
  title,
  labelSelect,
  actionsList,
  handleChangeSelectAction,
  actionSelected,
  isLockerSelector,
}) => {
  const rAction = useRef();

  return (
    <PortalModal>
      <ContentModal>
        <CloseModal>
          {modalTitle && <ModalTitle>{modalTitle}</ModalTitle>}
          <Tooltip title="close">
            <IconButton onClick={() => setOpen(null)}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </CloseModal>
        <TextModal>
          <ContentAlertText modalAlertTitle={modalAlertTitle}>
            <TitleAlert>{title}</TitleAlert>
          </ContentAlertText>
          <ContentSelect>
            <Form.Label style={{ fontSize: "16px", textAlign: "center" }}>
              {labelSelect}
            </Form.Label>
            <Select
              placeholder="Select"
              isDisabled={modalAlertTitle || isLockerSelector ? false : true}
              ref={rAction}
              options={actionsList}
              styles={SelectStyles}
              onChange={handleChangeSelectAction}
            />
          </ContentSelect>
        </TextModal>
        <div style={{ display: "inline-flex", margin: "auto", width: "100%" }}>
          <ButtonConfirm
            isDisabled={modalAlertTitle && actionSelected ? false : true}
            disabled={modalAlertTitle && actionSelected ? false : true}
            onClick={() => fn(open)}
          >
            Ok
          </ButtonConfirm>
        </div>
      </ContentModal>
    </PortalModal>
  );
};

export default ModalConfirmCaseUpdated;
